import ApiService from "@/core/services/api.service";
import {PURGE_AUTH} from "./auth.module";
import JwtService from "@/core/services/jwt.service";
import {SET_PAGINATE} from "./paginate.module";

// action types
export const ADD_ORDER = "addOrder";
export const GET_ORDERS = "getOrders";
export const GET_ORDER = "getOrder";
export const UPDATE_ORDER = "updateOrder";
export const UPDATE_ORDER_STATUS = "updateOrderStatus";
export const DELETE_ORDER = "deleteOrder";
export const DELETE_ITEM_TO_ORDER = "deleteItemToOrder";
export const ADD_ITEM_TO_ORDER = "addItemToOrder";
export const GET_NEW_ORDER_DETAILS = "getNewOrderDetails";

export const MORE_DELETE_ORDERS = "moreDeleteOrders";

export const RESTORE_ORDER = "restoreOrders";
export const MORE_RESTORE_ORDERS = "moreRestoreOrders";


export const GET_ORDER_TABLES = "getOrderTables";
export const GET_ORDER_TABLE = "getOrderTable";
export const GET_QTY_NEW_ORDERS = "getQtyNewOrder";



// mutation types
export const SET_ORDERS_ERROR = "setOrderErrors";
export const SET_ORDERS = "setOrders";
export const SET_ORDER = "setOrder";
export const SET_ORDER_LOAD = "setOrderLoad";
export const SET_NEW_ORDER_DETAILS = "setNewOrderDetails";

export const SET_ORDER_TABLES = "setOrderTables";
export const SET_ORDER_TABLE = "setOrderTable";

export const SET_NEW_QTY = "setNewQty";



const state = {
    errors: {},
    orders: [],

    ordersBadge: 0,

    orderTables: [],
    load: true,
    order: {
        ordered_items: [],
        delivery_type: {
            name: ''
        },
        payment: {
            status: '',
            sum: 0,
            type: '',
        }
    },

    orderTable: {
        files: [],
        name: '',
        description: '',
        qty: '',
        desired_value: '',
        desired_delivery_time: '',
        contact_name: '',
        contact_phone: '',
        contact_email: '',
    },

    statuses: [],
    delivery_types: [],
};

const getters = {
    gettersOrders(state) {
        return state.orders;
    },

    gettersOrderTables(state) {
        return state.orderTables;
    },

    gettersStatuses(state) {
        return state.statuses;
    },
    gettersDeliveryTypes(state) {
        return state.delivery_types;
    },
    paginateOrders() {
        return state.paginate;
    },
    gettersOrder(state) {
        return state.order;
    },

    gettersOrderTable(state) {
        return state.orderTable;
    },

    errorsOrders(){
        return state.errors;
    },
    getOrderLoad(){
        return state.load;
    }
};

const actions = {

    [ADD_ORDER](context, data){
        return new Promise((resolve, reject) => {
            context.commit(SET_ORDERS_ERROR, {});
            ApiService.post("/order/store", data)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                    if (response.status === 422){
                        context.commit(SET_ORDERS_ERROR, response.data.errors);
                    }
                });
        });
    },


    [GET_ORDERS](context, data) {
        return new Promise((resolve, reject) => {
            context.commit(SET_ORDER_LOAD, true);
            ApiService.post("/orders", data)
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_ORDERS, data);
                    context.commit(SET_PAGINATE, data);
                    context.commit(SET_ORDER_LOAD, false);
                })
                .catch(({ response }) => {
                    reject(response);
                    context.commit(SET_ORDERS_ERROR, response.data.errors);
                    context.commit(SET_ORDER_LOAD, false);
                });
        });
    },

    [GET_ORDER](context, id) {
        context.commit(SET_ORDER_LOAD, true);
        context.commit(SET_ORDERS_ERROR, {});
        ApiService.get("/order", id)
            .then(({ data }) => {
                context.commit(SET_ORDER, data);
                context.commit(SET_ORDER_LOAD, false);
            })
            .catch(({ response }) => {
                context.commit(SET_ORDERS_ERROR, response.data.errors);
                context.commit(SET_ORDER_LOAD, false);
            });
    },

    [UPDATE_ORDER](context, data) {
        if (JwtService.getToken()) {
            context.commit(SET_ORDERS_ERROR, {});
            return new Promise((resolve, reject) => {
                ApiService.update("/order/update", data.id, data.order)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_ORDERS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                        if (response.status === 422){
                            context.commit(SET_ORDERS_ERROR, response.data.errors);
                        }
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [UPDATE_ORDER_STATUS](context, data) {
        if (JwtService.getToken()) {
            context.commit(SET_ORDERS_ERROR, {});
            return new Promise((resolve, reject) => {
                ApiService.update("/order/update-status", data.id, {status: data.status})
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_ORDERS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                        if (response.status === 422){
                            context.commit(SET_ORDERS_ERROR, response.data.errors);
                        }
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },



    [GET_NEW_ORDER_DETAILS](context) {
        return new Promise((resolve, reject) => {
            ApiService.get("/new-order-details")
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_NEW_ORDER_DETAILS, data);
                })
                .catch(({ response }) => {
                    reject(response);
                    context.commit(SET_ORDERS_ERROR, response.data.errors);
                });
        });
    },

    [DELETE_ORDER](context, id) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.delete("/order/soft-delete", id)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_ORDERS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },


    [MORE_DELETE_ORDERS](context, ids) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.post("/orders/more-soft-delete", ids)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_ORDERS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },



    [RESTORE_ORDER](context, id){
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.get("/order/restore", id)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_ORDERS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [MORE_RESTORE_ORDERS](context, ids) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.post("/orders/more-restore", ids)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_ORDERS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [GET_ORDER_TABLES](context, data) {
        return new Promise((resolve, reject) => {
            context.commit(SET_ORDER_LOAD, true);
            ApiService.post("/order-tables", data)
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_ORDER_TABLES, data);
                    context.commit(SET_PAGINATE, data);
                    context.commit(SET_ORDER_LOAD, false);
                })
                .catch(({ response }) => {
                    reject(response);
                    context.commit(SET_ORDERS_ERROR, response.data.errors);
                    context.commit(SET_ORDER_LOAD, false);
                });
        });
    },

    [GET_ORDER_TABLE](context, id) {
        context.commit(SET_ORDER_LOAD, true);
        context.commit(SET_ORDERS_ERROR, {});
        return new Promise((resolve, reject) => {
            ApiService.get("/order-table/show", id)
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_ORDER_TABLE, data);
                    context.commit(SET_ORDER_LOAD, false);
                })
                .catch(({ response }) => {
                    reject(response);
                    context.commit(SET_ORDERS_ERROR, response.data.errors);
                    context.commit(SET_ORDER_LOAD, false);
                });
        });
    },

    [GET_QTY_NEW_ORDERS](context) {
        return new Promise((resolve, reject) => {
        ApiService.get("/news-qty/order")
            .then(({ data }) => {
                resolve(data);
                context.commit(SET_NEW_QTY, data);
            })
            .catch(({ response }) => {
                reject(response);
            });
        });
    },


};

const mutations = {
    [SET_ORDERS_ERROR](state, error) {
        state.errors = error;
    },

    [SET_ORDERS](state, data) {
        state.orders = data.data;
    },

    [SET_ORDER_TABLES](state, data) {
        state.orderTables = data.data;
    },



    [SET_NEW_ORDER_DETAILS](state, product) {
        state.delivery_types = product.delivery_types;
    },

    [SET_ORDER](state, product) {
        state.order = product.order;
        state.statuses = product.statuses;
        state.delivery_types = product.delivery_types;
    },

    [SET_ORDER_TABLE](state, data) {
        state.orderTable = data;
    },



    [SET_ORDER_LOAD](state, load) {
        state.load = load;
    },

    [SET_NEW_QTY](state, qty) {
        state.ordersBadge = qty;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};
